module.exports = __webpack_public_path__ + "img/lambda_logo.10556d6e.svg";